var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTl = function SvgTl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 0a11.95 11.95 0 0 0-7.715 2.809l12.933 9.19L4.285 21.19A11.95 11.95 0 0 0 12 24c6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.515 3.515c-4.687 4.687-4.687 12.285 0 16.971L12 12.001 3.515 3.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m3.327 9.251 1.826 1.729L7.36 9.777l-1.08 2.27 1.827 1.73-2.493-.325-1.08 2.27-.461-2.471-2.494-.325 2.208-1.203-.461-2.472Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTl;